<template>
  <div class="inventory-category-page">
    <div class="toolbar">
      <Button color="primary" @click="openCreate" icon="h-icon-plus">新增类别</Button>
    </div>
    <Table :datas="categoryList" :loading="loading">
      <TableItem title="类别编码" prop="code" align="center" :width="120"></TableItem>
      <TableItem title="类别名称" prop="name" align="left"></TableItem>
      <TableItem title="排序" prop="sort" align="center" :width="80"></TableItem>
      <TableItem title="备注" prop="remark" align="left"></TableItem>
      <TableItem title="操作" align="center" :width="150">
        <template slot-scope="{data}">
          <Button text size="xs" @click="openEdit(data)">编辑</Button>
          <Button text size="xs" color="red" @click="remove(data)">删除</Button>
        </template>
      </TableItem>
    </Table>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="modalVisible" :hasCloseIcon="true" :width="500">
      <div class="modal-header">
        <div class="modal-title">{{ modalTitle }}</div>
      </div>
      <Form ref="form" :model="formData" :rules="rules" labelPosition="left" :labelWidth="100">
        <FormItem label="类别编码" prop="code">
          <Input v-model="formData.code" placeholder="请输入类别编码"/>
        </FormItem>
        <FormItem label="类别名称" prop="name">
          <Input v-model="formData.name" placeholder="请输入类别名称"/>
        </FormItem>
        <FormItem label="上级类别">
          <Select v-model="formData.parentId" :datas="parentCategoryList" 
                  keyName="id" titleName="name" :nullOption="true" placeholder="无上级类别"/>
        </FormItem>
        <FormItem label="排序">
          <Input v-model.number="formData.sort" type="number" placeholder="请输入排序号"/>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="formData.remark" placeholder="请输入备注"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button color="primary" @click="save" :loading="saving">保存</Button>
        <Button @click="modalVisible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import inventory from '@/api/inventory';

export default {
  name: "InventoryCategory",
  props: {
    accountSetsId: Number
  },
  data() {
    return {
      loading: false,
      categoryList: [],
      modalVisible: false,
      modalTitle: '新增类别',
      formData: {
        id: null,
        code: '',
        name: '',
        parentId: null,
        sort: 0,
        remark: ''
      },
      rules: {
        code: [{ required: true, message: '请输入类别编码' }],
        name: [{ required: true, message: '请输入类别名称' }]
      },
      saving: false
    };
  },
  computed: {
    parentCategoryList() {
      if (!Array.isArray(this.categoryList)) {
        return [];
      }
      // 添加空选项
      const list = this.categoryList.filter(item => !item.parentId);
      return list;
    }
  },
  watch: {
    accountSetsId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      inventory.category.listByAccountSetsId(this.accountSetsId)
        .then(res => {
          this.categoryList = res.data || [];
        })
        .catch(() => {
          this.categoryList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openCreate() {
      this.modalTitle = '新增类别';
      this.formData = {
        id: null,
        code: '',
        name: '',
        parentId: null,
        sort: 0,
        remark: ''
      };
      this.modalVisible = true;
    },
    openEdit(data) {
      this.modalTitle = '编辑类别';
      this.formData = { ...data };
      this.modalVisible = true;
    },
    async save() {
      const valid = await this.$refs.form.valid();
      if (!valid) return;

      this.saving = true;
      const data = { ...this.formData, accountSetsId: this.accountSetsId };
      try {
        if (data.id) {
          await inventory.category.update(data);
        } else {
          await inventory.category.create(data);
        }
        this.$Message.success('保存成功');
        this.modalVisible = false;
        this.loadData();
      } catch (e) {
        this.$Message.error(e.msg || '保存失败');
      } finally {
        this.saving = false;
      }
    },
    remove(data) {
      this.$Confirm('确定删除该类别吗？', '提示')
        .then(() => {
          inventory.category.delete(data.id)
            .then(() => {
              this.$Message.success('删除成功');
              this.loadData();
            });
        });
    }
  }
};
</script>

<style scoped>
.inventory-category-page {
  padding: 10px;
}
.toolbar {
  margin-bottom: 16px;
}
.modal-header {
  margin: -20px -20px 20px -20px;
  padding: 15px 20px;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  border-radius: 4px 4px 0 0;
}
.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
</style>
